import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import 'intro.js/introjs.css';
import './walkthrough/introjs-custom.css';

// Register service worker for PWA
import { registerSW } from 'virtual:pwa-register';

// Register service worker with auto-update (no annoying prompts)
registerSW({
  onNeedRefresh() {
    // Auto-update silently - new content will be available on next page load
    console.log('New content available, will update on next visit');
  },
  onOfflineReady() {
    console.log('App ready to work offline');
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
